import { Navbar, Container, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useUser } from '../context/UserContext';
import { updateLogout } from "../services/api";

function TopNavbar() {
  const { user, setUser } = useUser();
  const navigate = useNavigate();
  
  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    setUser(storedUser ? JSON.parse(storedUser) : null);
  }, []);

  //const handleLogout = () => {
  //  localStorage.removeItem('authToken');
  //  localStorage.removeItem('user');
  //  setUser(null); // ← actualiza el estado local
  //  navigate('/login');
  //};

  const handleLogout = async () => {
    try {
      const stored = localStorage.getItem("user");
      if (stored) {
        const loginResponse = JSON.parse(stored);
        const logId = loginResponse.log_id;
        const token = loginResponse.access_token;

        await updateLogout(logId, token);
      }
    } catch (error) {
      console.error("Error al registrar logout:", error);
    } finally {
      // 🔹 Limpieza local
      localStorage.removeItem("loginResponse");
      setUser(null);
      navigate("/login");
    }
  };

  return (
    <Navbar bg="light" expand="lg" className="shadow-sm">
      <Container fluid className="justify-content-between">
        {user ? (
          <>          
            <span className="navbar-text text-muted">
              {user ? `Bienvenido, ${user.user.username || user.user.email}` : 'Sesión no iniciada'}
            </span>
            <Button variant="outline-danger" size="sm" onClick={handleLogout}>
              Cerrar sesión
            </Button>
          </>
        ) : (
          <span className="navbar-text text-muted">No autenticado</span>
        )}
      </Container>
    </Navbar>
  );
}

export default TopNavbar;